let isAuthenticated: any = sessionStorage.getItem("auth");
if (!isAuthenticated) {
  isAuthenticated = false;
}
export const authReducer = (state = isAuthenticated, action: any) => {
  switch (action.type) {
    case "IS_LOGGED_IN": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const tokenReducer = (state: any = {}, action: any) => {
  switch (action.type) {
    case "AUTH_TOKEN": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const userReducer = (state: any = {}, action: any) => {
  switch (action.type) {
    case "USER": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const loginReducer = (state: any = {}, action: any) => {
  switch (action.type) {
    case "AUTHENTICATE": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const regionStateReducer = (state: any = [], action: any) => {
  switch (action.type) {
    case "REGIONS_STATE": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const regionTerritoryReducer = (state: any = [], action: any) => {
  switch (action.type) {
    case "REGIONS_TERRITORY": {
      return action.payload;
    }

    default:
      return state;
  }
};
